import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './app/app';
import { cacheRtl, theme } from './theme/theme';
import { ContextProvider } from './context/context';

import './main.css';
import { queryClient } from './react-query';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const ThemeProviderWrapper = () => {
  return (
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  );
};

root.render(
  <StrictMode>
    <BrowserRouter>
      <CacheProvider value={cacheRtl}>
        <QueryClientProvider client={queryClient}>
          <ContextProvider>
            <ThemeProviderWrapper></ThemeProviderWrapper>
          </ContextProvider>
        </QueryClientProvider>
      </CacheProvider>
    </BrowserRouter>
  </StrictMode>
);
